import React, { useState } from "react"
import { Container } from "@bootstrap-styled/v4"
import { StaticQuery, graphql } from "gatsby"
import { Link } from "react-scroll"

import TransitionLink from "../../util/TransitionLink"
import navData from "./data"
import NavItem from "./NavItem"
import LanguagesButton from "./LanguagesButton/index.js"

import * as S from "./styled"

const Navbar = props => {
  const [isSticky, setSticky] = useState(false)
  const [isNavToggled, toggleNav] = useState(false)
  if (typeof window !== `undefined`) {
    function handleScroll() {
      console.log("handle")
      if (window.scrollY > 60) {
        if (isSticky === false) {
          setSticky(true)
        }
      } else {
        if (isSticky === true) {
          setSticky(false)
        }
      }
    }

    window.addEventListener("scroll", handleScroll)
  }

  return (
    <StaticQuery
      query={graphql`
        query {
          brandImage: file(relativePath: { eq: "brand.png" }) {
            childImageSharp {
              fluid(maxWidth: 150) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
          content: allMarkdownRemark(
            filter: { fileAbsolutePath: { regex: "/(dados_gerais)/" } }
          ) {
            nodes {
              frontmatter {
                url_linkedin
                url_instagram
                url_whatsapp
                email
                telefone
              }
            }
          }
        }
      `}
      render={data => (
        <S.NavbarWrapper isSticky={isSticky}>
          <Container style={{ position: "relative" }}>
            <S.NavbarContent>
              {props.location.pathname === "/" ? (
                <Link
                  to="section-home"
                  href="/"
                  smooth={true}
                  duration={400}
                  aria-label="Voltar para o início"
                >
                  <S.NavbarAvatar
                    isSticky={isSticky}
                    fluid={data.brandImage.childImageSharp.fluid}
                  />
                </Link>
              ) : (
                <TransitionLink
                  to="/"
                  href="/"
                  aria-label="Ir para página inicial"
                  state={{
                    SCROLLTO: {
                      name: "section-home",
                      offset: 0,
                    },
                  }}
                >
                  <S.NavbarAvatar
                    isSticky={isSticky}
                    fluid={data.brandImage.childImageSharp.fluid}
                  />
                </TransitionLink>
              )}

              <S.NavbarNav
                onMouseDown={() => setTimeout(() => toggleNav(false), 100)}
                isToggled={isNavToggled}
              >
                <S.NavbarNavList>
                  {navData.links.map(item => (
                    <NavItem path={props.location.pathname} {...item} />
                  ))}
                  <LanguagesButton aria-label="Exibir idiomas" />
                </S.NavbarNavList>
                {/* Mobile only */}
                <S.NavbarNavSocialWrapper>
                  Siga-nos nas redes sociais:
                  <S.NavbarNavSocialList>
                    {navData.social.map(item => {
                      const Icon = item.icon
                      return (
                        <S.NavbarNavSocialItem key={item.key}>
                          <a
                            href={data.content.nodes[0].frontmatter[item.key]}
                            target="_blank"
                            title={item.label}
                          >
                            <Icon color="#fff"></Icon>
                          </a>
                        </S.NavbarNavSocialItem>
                      )
                    })}
                  </S.NavbarNavSocialList>
                </S.NavbarNavSocialWrapper>
              </S.NavbarNav>
              <S.NavbarToggler
                isToggled={isNavToggled}
                onClick={() => toggleNav(!isNavToggled)}
                aria-label="Abrir e fechar barra de navegação"
              >
                <div className="close">
                  <navData.icons.Close color="#fff"></navData.icons.Close>
                </div>
                <div className="show">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </S.NavbarToggler>
            </S.NavbarContent>
          </Container>
          <S.Backdrop show={isNavToggled} onClick={() => toggleNav(false)} />
        </S.NavbarWrapper>
      )}
    />
  )
}

export default Navbar
